import React from 'react';
import { Phone, Shield, Star } from 'lucide-react';

/**
 * TrustPhoneBar - Trust-Balken direkt unter der Navbar.
 * Alle Elemente in EINER Zeile, mittig zentriert.
 * Telefon, Öffnungszeiten, TÜV, Bewertung – alle nebeneinander.
 */
const TrustPhoneBar = () => {
  return (
    <div
      className="fixed top-0 xl:top-16 left-0 right-0 z-40 bg-gradient-to-r from-emerald-600 to-teal-600"
      data-testid="trust-phone-bar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center flex-wrap gap-x-6 gap-y-1 py-1.5">

          {/* Telefon - kompletter Block pulsiert als Eye-Catcher */}
          <a
            href="tel:+4952425835480"
            className="flex items-center gap-4 phone-pulse group cursor-pointer"
            data-testid="trust-phone-link-wrapper"
          >
            <div
              className="bg-white p-2 rounded-full flex items-center justify-center shadow-md group-hover:scale-110 transition-transform"
              data-testid="trust-phone-icon"
            >
              <Phone className="w-6 h-6 sm:w-7 sm:h-7 text-emerald-600" />
            </div>
            <span
              className="text-white font-black text-xl sm:text-2xl leading-tight whitespace-nowrap tracking-wide drop-shadow-md"
              data-testid="trust-phone-link"
            >
              05242 583 5480
            </span>
          </a>

          {/* Öffnungszeiten – nur auf Tablet/Desktop sichtbar */}
          <span
            className="hidden md:inline-block text-white text-base sm:text-lg leading-tight whitespace-nowrap"
            data-testid="trust-hours"
          >
            Öffnungszeiten Montag bis Freitag von 8 bis 20 Uhr
          </span>

          {/* TÜV – nur Tablet/Desktop */}
          <div className="hidden md:flex items-center gap-1.5" data-testid="trust-tuev">
            <Shield className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
            <span className="text-white text-base sm:text-lg leading-tight font-semibold whitespace-nowrap">TÜV</span>
          </div>

          {/* Bewertung – nur Tablet/Desktop */}
          <div className="hidden md:flex items-center gap-1.5" data-testid="trust-rating">
            <Star className="w-4 h-4 sm:w-5 sm:h-5 fill-amber-400 text-amber-400" />
            <span className="text-white text-base sm:text-lg leading-tight font-semibold whitespace-nowrap">4.9/5</span>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TrustPhoneBar;
